import _ from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ImmutablePropTypes from 'react-immutable-proptypes';
import AddedToShelfWorkflowContainer from 'app/components/shared/AddedToShelfWorkflow/AddedToShelfWorkflowContainer';
import WorkflowActions from '../../actions/WorkflowActions';

import {
  ITEM_TRANSACTION_WORKFLOW,
  ADDED_TO_SHELF_WORKFLOW,
  BATCH_ADDED_TO_SHELF_WORKFLOW,
  BATCH_CANCEL_HOLD_WORKFLOW
} from '../../constants/WorkflowConstants';

import ItemTransactionWorkflowContainer from './ItemTransactionWorkflowContainer';
import BatchAddToShelfWorkflow from '../borrowing/shared/BatchAddedToShelfWorkflow';
import BatchCancelHoldWorkflowContainer from '../shared/ItemTransactions/components/cancel-hold-workflow-view/components/BatchCancelHoldWorkflowView/BatchCancelHoldWorkflowContainer';

function WorkflowContainer({
  id,
  itemPosition,
  itemPositionGrouped,
  totalCount,
  workflow,
  actions,
  children,
  ...otherProps
}) {
  const currentWorkflowName = workflow && workflow.get('name');
  const boundWorkflowActions = _.mapValues(actions, action => action.bind(this, id));
  let workflowComponent = null;
  const closeWorkflow = () => boundWorkflowActions.updateWorkflow(null);
  switch (currentWorkflowName) {
    case ITEM_TRANSACTION_WORKFLOW:
      workflowComponent = (
        <ItemTransactionWorkflowContainer
          itemPosition={itemPosition}
          itemPositionGrouped={itemPositionGrouped}
          totalCount={totalCount}
          workflowId={id}
          metadataId={workflow.getIn(['view', 'metadataId'])}
          messagingId={workflow.getIn(['view', 'messagingId'])}
          holdsId={workflow.getIn(['view', 'holdsId'])}
          closeWorkflow={closeWorkflow}
          view={workflow.getIn(['view', 'step'])}
          {...otherProps}
        />
      );
      break;
    case ADDED_TO_SHELF_WORKFLOW:
      workflowComponent = (
        <AddedToShelfWorkflowContainer
          id={id}
          itemPosition={itemPosition}
          itemPositionGrouped={itemPositionGrouped}
          totalCount={totalCount}
          metadataId={workflow.get('metadataId')}
          closeWorkflow={closeWorkflow}
          view={workflow.get('view')}
          {...otherProps}
        />
      );
      break;
    case BATCH_ADDED_TO_SHELF_WORKFLOW:
      workflowComponent = (
        <BatchAddToShelfWorkflow
          workflowId={id}
          closeWorkflow={closeWorkflow}
          shelfName={workflow.getIn(['view', 'shelfName'])}
          {...otherProps}
        />
      );
      break;
    case BATCH_CANCEL_HOLD_WORKFLOW:
      workflowComponent = (
        <BatchCancelHoldWorkflowContainer
          workflowId={id}
          closeWorkflow={closeWorkflow}
          holdIds={workflow.get('view')}
          {...otherProps}
        />
      );
      break;
    default:
      workflowComponent = null;
      break;
  }

  return children(workflowComponent, boundWorkflowActions);
}

WorkflowContainer.displayName = 'WorkflowContainer';
WorkflowContainer.propTypes = {
  id: PropTypes.string,
  workflow: ImmutablePropTypes.mapContains({
    name: PropTypes.string,
    view: PropTypes.any
  }),
  actions: PropTypes.objectOf(PropTypes.func).isRequired,
  children: PropTypes.func.isRequired
};

const mapStateToProps = (state, ownProps) => {
  const id = ownProps.id;
  return {
    workflow: state.getIn(['ui', 'workflow', id]),
    id
  };
};

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(WorkflowActions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(WorkflowContainer);
